module.exports = __webpack_public_path__ + "img/Inter-Escaldes.e3e25cc1.png";